export default "__VITE_ASSET__3b916ac8__"